import { render, staticRenderFns } from "./ConfirmDeleteQuestion.vue?vue&type=template&id=7a8e478b&"
import script from "./ConfirmDeleteQuestion.vue?vue&type=script&lang=js&"
export * from "./ConfirmDeleteQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports